/**
 * Name schema
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import {
	BP,
	ISchemaConstString,
	ISchemaStringWithConstOpts,
	ISchemaValue
} from "@adapptio/lib-blueprint";

import { termsEditor } from "../terms";

/**
 * Name schema
 *
 * @param opts Options
 */
export function NameSchema(
	opts: Partial<ISchemaStringWithConstOpts> = { alias: "name" }
): ISchemaValue<ISchemaConstString> {
	return BP.String({
		...termsEditor.schemas.common.name,
		...opts
	});
}
